<template>
    <div>
        <h1>Create new airline</h1>
        <div class="box">
            <Errors/>
            <form class="form" v-on:submit.prevent="createAirline">

                <AirlineFields/>

                <div class="form-wrap form-submit">
                <div v-if="this.getLoadStatus">
                    <button type="submit" class="button" disabled>Creating...</button>
                </div>
                <div v-else>
                    <button type="submit" class="button">Create Airline</button>
                </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
// import axios from 'axios';
import AirlineFields from '@/components/AirlineFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
    name: 'AirlineCreate',
    computed: mapGetters(['getLoadStatus']),
    data () {
        return {
            airline: {},
            errors: null,
            // tours: [],
        }
    },
    components: {
        AirlineFields,
        Errors,
    },
    methods: {
        createAirline () {
            this.$store.dispatch('setLoadStatus')
            let formData = new FormData();

            formData.append('name', this.airline.name);
            formData.append('contact_name', this.airline.contact_name);
            formData.append('web_check_in_before_days', this.airline.web_check_in_before_days);
            formData.append('airline_content', this.airline.airline_content);
            formData.append('instruction_doc_file', this.airline.instruction_doc);
            formData.append('checkin_video_desktop_url', this.airline.checkin_video_desktop_url || '');
            formData.append('checkin_video_mobile_url', this.airline.checkin_video_mobile_url || '');
            formData.append('airline_code', this.airline.airline_code);
            formData.append('flight_times_code', this.airline.flight_times_code);
            formData.append('flight_budget_code', this.airline.flight_budget_code);
            
            fetch(this.$api + 'airlines', {
                method: 'POST',
                body: formData,
                headers:{
                  'Accept': 'application/json',
                  'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.errors = response.errors
                if(response.success) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                    this.$router.push({ name: 'airline-edit', params: { id: response.data.id }})
                } else {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                this.$store.dispatch('setLoadStatus')
            });
        },
        // getTours() {
        //     axios.get(this.$api + 'tours')
        //     .then((response) => {
        //     this.tours = response.data.data
        //     // console.log(this.tours)
        //     });
        // },
    },
    mounted() {
        // this.getTours()
        // console.log(tours)
    }
}
</script>
